import { useState, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { IconContext } from 'react-icons'
import NavbarData from './data' 
import ReactTooltip from 'react-tooltip'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorStatus, logApiError } from 'services/apiError'
import DropdownMenu from 'components/DropDownMenu'
import { FaQuestion, FaSignInAlt, FaSignOutAlt } from 'react-icons/fa'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'

import {
  Container,
  ProfilePicture,
  NavItem,
  NavButton,
  Label
} from '../styles'

export default function CompanyNavbar () {
  const [loading, setLoading] = useState (false)
  const signed = AuthService.isSigned ()
  const [company, setCompany] = useState (AuthService.getUser ())
  const token = AuthService.getToken ()
  const navigate = useNavigate ()

  useEffect (() => {
    const handleUserUpdate = () => setCompany (AuthService.getUser ())
    window.addEventListener ('userUpdated', handleUserUpdate)

    return () => {
      window.removeEventListener ('userUpdated', handleUserUpdate)
    }
  }, [])

  const handleSignOut = async () => {
    try {
      setLoading (true)
      await cutileiApi.delete ('/auth/companies', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      setLoading (false)
      AuthService.companySignOut ()
      navigate ('/company', { replace: true })
    } catch (error) {
      setLoading (false)
      logApiError (error)
      if (getApiErrorStatus (error) === 401) {
        AuthService.companySignOut ()
        navigate ('/company', { replace: true })
      }
    }
  }

  const renderHelpMenu = () => (
    <NavItem>
      <DropdownMenu
        id='help'
        label='Ajuda'
        position='right'
        icon={<FaQuestion/>}
        items={[
          { label: 'Política de Privacidade', path: '/privacy-policy' },
          { label: 'Termos de Uso', path: '/terms' },
          { label: 'Fale com a Cutilei', href: 'https://wa.me/message/SH5AWAQ6UP4IF1' }
        ]}
      />
    </NavItem>
  )

  return (
    <IconContext.Provider value={{color: '#252525'}}>
      <Container>
        {signed ? (
          <>
            <ProfilePicture src={company.logo} alt={company.name}/>
            {NavbarData.map ((item, index) => (
              <NavItem key={index}>
                <NavLink
                  to={item.path}
                  end={item.path === '/company'}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  data-for={item.id}
                  data-tip
                >
                  {item.icon}
                </NavLink>
                <ReactTooltip
                  id={item.id}
                  effect='solid'
                  place='right'
                  backgroundColor='#252525'
                  tooltipRadius='10'
                >
                  <Label>{item.label}</Label>
                </ReactTooltip>
              </NavItem>
            ))}
            {renderHelpMenu ()}
            <NavItem>
              <NavButton onClick={handleSignOut} data-for='logout' data-tip>
                {loading ? (
                  <ButtonLoading style={{margin: 0}}/>
                ) : (
                  <FaSignOutAlt/>
                )}
              </NavButton>
              <ReactTooltip
                id='logout'
                effect='solid'
                place='right'
                backgroundColor='#252525'
                tooltipRadius='10'
              >
                <Label>Sair</Label>
              </ReactTooltip>
            </NavItem>
          </>
          ) : (
            <>
              <NavItem>
                <NavLink to='/login' className={({ isActive }) => isActive ? 'active' : ''}>
                  <FaSignInAlt/>
                </NavLink>
              </NavItem>
              {renderHelpMenu ()}
            </>
          )
        }
      </Container>
    </IconContext.Provider>
  )
}
